<template>
  <va-create-layout>
    <videos-form :title="title" :item="item"></videos-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
